import { Typography } from '@/components'
import { ErrorContainer } from './styles'
import { useTranslation } from 'react-i18next'
import { AlertCircleIcon } from 'lucide-react'

const DocumentsPageError = () => {
  const { t } = useTranslation()

  return (
    <ErrorContainer>
      <AlertCircleIcon />
      <Typography variant="h5">{t('documentsPage.error')}</Typography>
    </ErrorContainer>
  )
}

export default DocumentsPageError
